import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { SubdistrictTable } from "@/features/subdistrict/SubdistrictTable";

export function SubdistrictIndex() {
  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/district",
            label: "District (Kec)",
          },
        ]}
      />
      <H2>District (Kec) List</H2>
      <SubdistrictTable />
    </>
  );
}
